//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleFontSize = '3rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
		titleFontSize = '2rem';
	}
	if (isMobile) {
		titleFontSize = '1rem';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: `flex`,
				position: `relative`,
				flexDirection: 'column',
				height: `auto`,
				width: `100%`,
				marginTop: mt ? '1rem' : 'unset',
			};
		},
		image: () => {
			return {
				width: '100%',
				height: 'auto',
			};
		},
		titleStyle: ({alignment}) => {
			let isLeft = alignment === 'left';
			return {
				margin: `auto ${isLeft ? 'auto' : `${minimumMarginX}rem`} auto ${
					isLeft ? `${minimumMarginX}rem` : 'auto'
				}`,
				top: `50%`,
				width: `60%`,
				position: `absolute`,
				transform: `translate(0, -50%)`,
				fontSize: titleFontSize,
				right: isLeft ? 'unset' : 0,
			};
		},
	};
}

export default Styles;
